export default {
  water2nd: 'Thủy Nhị Cục',
  wood3rd: 'Mộc Tam Cục',
  metal4th: 'Kim Tứ Cục',
  earth5th: 'Thổ Ngũ Cục',
  fire6th: 'Hỏa Lục Cục',
} as const;
